import { createRouter } from "@tanstack/react-router"
import { RouterErrorFallback } from "@/components/RouterErrorFallback"
import { routeTree } from "./routeTree.gen"

export const router = createRouter({
  routeTree,
  defaultErrorComponent: RouterErrorFallback,
  defaultPreload: "intent",
  defaultPreloadDelay: 50,
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
